import * as z from "zod";

export const CropTypeCodeEnum = {
    BROCCOLI: "BROCCOLI",
    BRUSSELS_SPROUT: "BRUSSELS_SPROUT",
    CABBAGE: "CABBAGE",
    CARROT: "CARROT",
    CAULIFLOWER: "CAULIFLOWER",
    CELERY: "CELERY",
    GARLIC: "GARLIC",
    LETTUCE: "LETTUCE",
    ONION: "ONION",
    SPINACH: "SPINACH",
    RADISH: "RADISH",
    EGGPLANT: "EGGPLANT",
    BELL_PEPPER: "BELL_PEPPER",
    TOMATO: "TOMATO",
    MELON: "MELON",
    CUCUMBER: "CUCUMBER",
    WINTER_SQUASH: "WINTER_SQUASH",
    ZUCCHINI: "ZUCCHINI",
    SWEET_MELON: "SWEET_MELON",
    WATERMELON: "WATERMELON",
    BEET: "BEET",
    YUCCA: "YUCCA",
    PARSNIP: "PARSNIP",
    POTATO: "POTATO",
    SWEET_POTATO: "SWEET_POTATO",
    TURNIP: "TURNIP",
    SUGAR_BEET: "SUGAR_BEET",
    GREEN_BEANS: "GREEN_BEANS",
    CHICKPEA: "CHICKPEA",
    BROAD_BEANS: "BROAD_BEANS",
    BLACK_GRAM: "BLACK_GRAM",
    COWPEAS: "COWPEAS",
    PEANUT: "PEANUT",
    LENTILS: "LENTILS",
    PEAS: "PEAS",
    SOYBEAN: "SOYBEAN",
    ARTICHOKE: "ARTICHOKE",
    ASPARAGUS: "ASPARAGUS",
    MINT: "MINT",
    STRAWBERRY: "STRAWBERRY",
    COTTON: "COTTON",
    FLAX: "FLAX",
    SISAL: "SISAL",
    CASTOR_OIL_PLANT: "CASTOR_OIL_PLANT",
    CANOLA: "CANOLA",
    SAFFLOWER: "SAFFLOWER",
    SESAME: "SESAME",
    SUNFLOWER: "SUNFLOWER",
    BARLEY: "BARLEY",
    OATS: "OATS",
    SPRING_WHEAT: "SPRING_WHEAT",
    WINTER_WHEAT: "WINTER_WHEAT",
    CORN_GRAIN: "CORN_GRAIN",
    CORN_SWEET: "CORN_SWEET",
    MILLET: "MILLET",
    SORGHUM_GRAIN: "SORGHUM_GRAIN",
    SORGHUM_SWEET: "SORGHUM_SWEET",
    RICE: "RICE",
    ALFALFA: "ALFALFA",
    MEADOW_GRASS: "MEADOW_GRASS",
    CLOVER: "CLOVER",
    RYE_GRASS: "RYE_GRASS",
    PASTURE_ROTATION: "PASTURE_ROTATION",
    PASTURE_EXTENSIVE: "PASTURE_EXTENSIVE",
    TURFGRASS: "TURFGRASS",
    BANANA: "BANANA",
    CACAO: "CACAO",
    COFFEE: "COFFEE",
    DATE_PALM: "DATE_PALM",
    PALMS: "PALMS",
    PINEAPPLE: "PINEAPPLE",
    RUBBER_TREE: "RUBBER_TREE",
    TEA: "TEA",
    BLACKBERRIES: "BLACKBERRIES",
    GRAPES_TABLE: "GRAPES_TABLE",
    GRAPES_WINE: "GRAPES_WINE",
    HOPS: "HOPS",
    ALMONDS: "ALMONDS",
    APPLES: "APPLES",
    CHERRIES: "CHERRIES",
    PEARS: "PEARS",
    PEACH: "PEACH",
    AVOCADO: "AVOCADO",
    CITRUS: "CITRUS",
    CONIFERS: "CONIFERS",
    KIWI: "KIWI",
    OLIVE: "OLIVE",
    PISTACHIO: "PISTACHIO",
    WALNUT_ORCHARD: "WALNUT_ORCHARD",
} as const;
export type CropTypeCodeEnum =
    (typeof CropTypeCodeEnum)[keyof typeof CropTypeCodeEnum];
export const CropTypeCodeEnumSchema = z.enum(CropTypeCodeEnum);

export const isCropTypeCode = (value: unknown): value is CropTypeCodeEnum =>
    CropTypeCodeEnumSchema.validate(value);
